import dayjs from 'dayjs';
import { MONTH_KEY_OPTIONS } from '@/shared/constants';

export const getMonthName = (month) => {
  return MONTH_KEY_OPTIONS[month] ?? undefined;
};

export const getYear = (year) => {
  return year ? parseInt(year, 10) : undefined;
};

export const isValidDateArray = (value) => {
  return (
    Array.isArray(value) &&
    value.length === 2 &&
    value.every((v) => typeof v === 'string' && dayjs(v, true).isValid())
  );
};
